<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm">{{ $t('gradingdefinition.copyFrom') }}</h4>
        <ts-modal-close-button />
      </div>
      <ts-card-wrapper>
        <form>
          <div class="row m-b-15">
            <div class="col-md-12">
              <label class="col-form-label control-label required"
                >{{ $t('gradingdefinition.copyFromMainProgram') }}
              </label>
              <select class="form-control" v-model="model.acp_id">
                <option :value="null">{{ $t('select') }}</option>
                <option
                  v-for="(mainProgram, index) in main_programs"
                  :key="index"
                  :value="mainProgram.acp_id"
                >
                  {{ mainProgram.acp_name_foreign }}
                </option>
              </select>
              <div class="validate" v-if="errors.has('acp_id')">
                {{ errors.first('acp_id') }}
              </div>
            </div>
          </div>
          <div class="row m-b-15">
            <div class="col-md-12">
              <label class="form-label col-label required">{{
                $t('gradingdefinition.copyTO')
              }}</label>
              <select class="form-control" v-model="model.to_acp_id">
                <option :value="null">{{ $t('select') }}</option>
                <option
                  v-for="(mainProgram, index) in mainProgramFilter"
                  :key="index"
                  :value="mainProgram.acp_id"
                >
                  {{ mainProgram.acp_name_foreign }}
                </option>
              </select>
              <div class="validate" v-if="errors.has('to_acp_id')">
                {{ errors.first('to_acp_id') }}
              </div>
            </div>
          </div>
          <div class="row m-b-15">
            <div class="col-md-12">
              <label class="form-label col-label">{{
                $t('gradingdefinition.copyFromDefinitionType')
              }}</label>
              <select class="form-control" v-model="model.definition_type">
                <option :value="null">{{ $t('select') }}</option>
                <option
                  v-for="(grading, index) in definitonTypes"
                  :key="index"
                  :value="grading"
                >
                  {{ grading }}
                </option>
              </select>
            </div>
          </div>
          <div class="text-right">
            <ts-button class="mr-2" @click.prevent="$emit('close')">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              :waiting="waiting"
              class="btn-primary"
              @click.prevent="copy"
            >
              {{ $t('save') }}
            </ts-button>
          </div>
        </form>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { includes } from 'lodash'
export default {
  name: 'grading-definition-form',
  data () {
    return {
      errors: new Errors(),
      waiting: false,
      model: {
        acp_id: '',
        to_acp_id: '',
        definition_type: null
      },
      definitonTypes: ['Grading', 'Rating']
    }
  },
  computed: {
    ...mapState('gradingDefinition', ['main_programs']),
    mainProgramFilter () {
      if (this.main_programs) {
        return this.main_programs.filter(
          i => !includes([this.model.acp_id], i.acp_id)
        )
      }
      return []
    }
  },

  methods: {
    copy () {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('gradingDefinition/copy', {
          acp_id: this.model.acp_id,
          to_acp_id: this.model.to_acp_id,
          definition_type: this.model.definition_type
        })
        .then(response => {
          this.$emit('closeModal')
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    cancel () {
      this.errors = new Errors()
      this.clearInput()
    },
    clearInput () {
      this.model = {
        to_acp_id: '',
        acp_id: '',
        definition_type: ''
      }
    }
  }
}
</script>
